import { Navigate } from "react-router-dom";
import { Clock, ShieldAlert, XCircle, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Brand";

const CFG = {
  pending: {
    icon: Clock, tone: "text-blue-600 bg-blue-50",
    title: "Account in attesa di approvazione",
    body: "Grazie per esserti registrato a StayGuide. Il tuo account è in fase di approvazione per l'accesso alla beta privata. Ti avviseremo non appena sarà attivo.",
  },
  suspended: {
    icon: ShieldAlert, tone: "text-amber-600 bg-amber-50",
    title: "Account sospeso",
    body: "Il tuo accesso a StayGuide è temporaneamente sospeso. I tuoi dati e le tue guide sono al sicuro. Contattaci per maggiori informazioni.",
  },
  rejected: {
    icon: XCircle, tone: "text-slate-600 bg-slate-100",
    title: "Accesso non disponibile",
    body: "Al momento il tuo account non ha accesso alla beta privata di StayGuide.",
  },
};

export default function PendingApproval() {
  const { user, ready, logout } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  const status = user.approval_status || "approved";
  if (status === "approved") return <Navigate to={user.onboarded ? "/dashboard" : "/onboarding"} replace />;
  const cfg = CFG[status] || CFG.pending;
  const Icon = cfg.icon;
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6" data-testid="pending-screen">
      <div className="w-full max-w-sm text-center">
        <div className="flex justify-center mb-8"><Logo className="h-10" /></div>
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8">
          <div className={`w-16 h-16 rounded-2xl grid place-items-center mx-auto ${cfg.tone}`}>
            <Icon className="w-8 h-8" />
          </div>
          <h1 className="mt-5 font-display font-bold text-xl text-slate-900" data-testid="pending-title">{cfg.title}</h1>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed">{cfg.body}</p>
          <p className="mt-4 text-xs text-slate-400">{user.email}</p>
        </div>
        <button onClick={logout} data-testid="pending-logout"
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors">
          <LogOut className="w-4 h-4" /> Esci
        </button>
      </div>
    </div>
  );
}
